import { DisplayPost } from '../../utility/interfaces';

export interface SearchState {
    loading: boolean;
    results: DisplayPost[];
    value: string;
}

export const initialState: SearchState = {
    loading: false,
    results: [],
    value: '',
};

export const actions = {
    CLEAN_QUERY: 'CLEAN_QUERY',
    START_SEARCH: 'START_SEARCH',
    FINISH_SEARCH: 'FINISH_SEARCH',
    UPDATE_SELECTION: 'UPDATE_SELECTION',
};
